
<div class="confirmation">
    <div class="confirmation__basic-info">
        <div class="container">
            <div class="confirmation__cont">
                <div class="confirmation__title">
                    <h1>User Detail Confirmation</h1>
                    <h2>Basic Information</h2>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">First Name</p>
                        <p><b>Mary Angeline</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Middle Name</p>
                        <p><b>Zaragosa</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Last Name</p>
                        <p><b>Reyes</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Suffix</p>
                        <p><b>N/A</b></p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Email Address</p>
                        <p><b>marymary@gmail.com</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Mobile Number</p>
                        <p><b>1234567890</b></p>
                    </div>
                </div>
            </div>
        </div>
    </div>  
    <div class="confirmation__platforms">
        <div class="container">
            <div class="confirmation__title">
                <h2>Enrolled Platforms</h2>
            </div>
            <div class="row">
            </div>
        </div>
    </div>
    <div class="confirmation__personal-info">
        <div class="container">
            <div class="confirmation__title">
                <h2>Personal Information</h2>
            </div>
            <div class="row">
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Sex</p>
                    <p><b>Female</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Date of Birth</p>
                    <p><b>06/12/1985</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Nationality</p>
                    <p><b>Filipino</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Place of Birth</p>
                    <p><b>USA</b></p>
                </div>
                <div class="col-12 col-sm-6">
                    <p class="confirmation__label">Present Address</p>
                    <p><b>28 Payapa St., Barangay Bagong Diwa, Sto Cristobal, Caloocan City, Metro Manila, Philippines, 1800</b></p>
                </div>
                <div class="col-12 col-sm-6">
                    <p class="confirmation__label">Permanent Address</p>
                    <p><b>28 Payapa St., Barangay Bagong Diwa, Sto Cristobal, Caloocan City, Metro Manila, Philippines, 1800</b></p>
                </div>
                <div class="confirmation__title">
                    <h2>Beneficiary Information</h2>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Beneficiary Name</p>
                        <p><b>Maria Carmelita D. dela Cruz</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Relationship</p>
                        <p><b>Mother</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Date of Birth</p>
                        <p><b>06/15/1952</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Place of Birth</p>
                        <p><b>Philippines</b></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="confirmation__id">
        <div class="container">
            <div class="confirmation__title">
                <h2>Identification</h2>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="box col-sm-12">
                        <div class="box__cont box__cont--image">  
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <p class="confirmation__label">ID Number</p>
                            <p><b>123445667</b></p>
                        </div>
                        <div class="col-12 col-sm-6">
                            <p class="confirmation__label">Issued Date</p>
                            <p><b>06/12/1985</b></p>
                        </div>
                        <div class="col-12 col-sm-6">
                            <p class="confirmation__label">ID Type</p>
                            <p><b>Unified Multi-Purpose ID</b></p>
                        </div>
                        <div class="col-12 col-sm-6">
                            <p class="confirmation__label">Expiration Date</p>
                            <p><b>06/12/2025</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="confirmation__personal-info">
        <div class="container">
            <div class="confirmation__fatca">
                <h2>FATCA</h2>
            </div>
            <!-- <div class="row">
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Sex</p>
                    <p><b>Female</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Date of Birth</p>
                    <p><b>06/12/1985</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Nationality</p>
                    <p><b>Filipino</b></p>
                </div>
                <div class="col-12 col-sm-4">
                    <p class="confirmation__label">Place of Birth</p>
                    <p><b>USA</b></p>
                </div>
                <div class="col-12 col-sm-6">
                    <p class="confirmation__label">Present Address</p>
                    <p><b>28 Payapa St., Barangay Bagong Diwa, Sto Cristobal, Caloocan City, Metro Manila, Philippines, 1800</b></p>
                </div>
                <div class="col-12 col-sm-6">
                    <p class="confirmation__label">Permanent Address</p>
                    <p><b>28 Payapa St., Barangay Bagong Diwa, Sto Cristobal, Caloocan City, Metro Manila, Philippines, 1800</b></p>
                </div>
                <div class="confirmation__title">
                    <h2>Beneficiary Information</h2>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Beneficiary Name</p>
                        <p><b>Maria Carmelita D. dela Cruz</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Relationship</p>
                        <p><b>Mother</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Date of Birth</p>
                        <p><b>06/15/1952</b></p>
                    </div>
                    <div class="col-12 col-sm-4">
                        <p class="confirmation__label">Place of Birth</p>
                        <p><b>Philippines</b></p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>